/* eslint no-param-reassign: 0 */

import getUuid from 'widget/helpers/uuid';
import { MESSAGE_STATUS, MESSAGE_TYPE } from 'shared/constants/messages';

export default () => {
  if (!Array.prototype.last) {
    Object.assign(Array.prototype, {
      last() {
        return this[this.length - 1];
      },
    });
  }
};

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const isJSONValid = value => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

export const getTypingUsersText = (users = []) => {
  const count = users.length;
  const [firstUser, secondUser] = users;

  if (count === 1) {
    return ['TYPING.ONE', { user: firstUser.name }];
  }

  if (count === 2) {
    return [
      'TYPING.TWO',
      { user: firstUser.name, secondUser: secondUser.name },
    ];
  }

  return ['TYPING.MULTIPLE', { user: firstUser.name, count: count - 1 }];
};

export const createPendingMessage = data => {
  const timestamp = Math.floor(new Date().getTime() / 1000);
  const tempMessageId = getUuid();
  const {
    message,
    file,
    contentAttributes,
    content_attributes: contentAttributesSnake,
  } = data;
  const normalizedContentAttributes =
    contentAttributes || contentAttributesSnake;
  const pendingContactAttachments =
    normalizedContentAttributes?.contacts?.map((contact, index) => ({
      id: `${tempMessageId}-contact-${index}`,
      file_type: 'contact',
      fileType: 'contact',
      fallback_title: contact.phone_number || '',
      fallbackTitle: contact.phone_number || '',
      meta: {
        first_name: contact.first_name || '',
        firstName: contact.first_name || '',
        last_name: contact.last_name || '',
        lastName: contact.last_name || '',
        formatted_name: contact.formatted_name || contact.name || '',
        formattedName: contact.formatted_name || contact.name || '',
        email: contact.email || '',
      },
    })) || [];
  const tempAttachments = [{ id: tempMessageId }];
  let attachments = null;
  if (normalizedContentAttributes?.location) {
    const location = normalizedContentAttributes.location;
    attachments = [
      {
        id: tempMessageId,
        file_type: 'location',
        coordinates_lat: location.latitude,
        coordinates_long: location.longitude,
        fallback_title: [location.name, location.address]
          .filter(Boolean)
          .join(' — '),
      },
    ];
  } else if (pendingContactAttachments.length > 0) {
    attachments = pendingContactAttachments;
  } else if (file) {
    attachments = tempAttachments;
  }
  const pendingMessage = {
    ...data,
    content: message || null,
    id: tempMessageId,
    echo_id: tempMessageId,
    status: MESSAGE_STATUS.PROGRESS,
    created_at: timestamp,
    message_type: MESSAGE_TYPE.OUTGOING,
    conversation_id: data.conversationId,
    delivery_destination: data.delivery_destination || 'channel',
    attachments,
  };

  return pendingMessage;
};

export const convertToAttributeSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '_');
};

export const convertToCategorySlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

export const convertToPortalSlug = text => {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

/**
 * Strip curly braces, commas and leading/trailing whitespace from a search key.
 * Eg. "{{contact.name}}," => "contact.name"
 * @param {string} searchKey
 * @returns {string}
 */
export const sanitizeVariableSearchKey = (searchKey = '') => {
  return searchKey
    .replace(/[{}]/g, '') // remove all curly braces
    .replace(/,/g, '') // remove commas
    .trim();
};

/**
 * Convert underscore-separated string to title case.
 * Eg. "round_robin" => "Round Robin"
 * @param {string} str
 * @returns {string}
 */
export const formatToTitleCase = str => {
  return (
    str
      ?.replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())
      .trim() || ''
  );
};
